import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import S1_Header from "./pages/MainPage/S1_Header";
import S3_About from "./pages/MainPage/S2_About";
import S3_Token from "./pages/MainPage/S3_Token";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route exact path="/" element={<S1_Header />} />
          <Route exact path="/about" element={<S3_About />} />
          <Route exact path="/tokenomics" element={<S3_Token />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
